import React										from 'react';
import {Route, Routes, useParams}					from 'react-router-dom';

import Header										from '../Header/Header';
import Devices										from './Devices';
import DevicesAdd									from './DevicesAdd';
import DevicesMdm									from './MDM/MdmHome';
import MdmImport									from './MDM/MdmImport';
import Badge										from '../ressources/components/Badge';

import {useAppSelector}								from '../app/hooks';
import {TabsData}									from '../ressources/components/Tabs/interface';

import {ft_checkRight}								from '../ressources/functions/userFunction';

import LANGUAGE										from '../ressources/language';

import './Devices.css';


function MainDevices() {
	const user = useAppSelector(state => state.user.data);
	const devices = useAppSelector(state => state.devices.data);
	const company = useAppSelector(state => state.company.data);
	const lang = useAppSelector(state => state.settings.lang);

	const params = useParams();
	const TEXTE = LANGUAGE(lang);
	const MENU_DATA: TabsData[] = [
		{value: '', render: TEXTE.header.devices.yourDevices},
		{
			value:                  'mdm',
			minimizeHeaderNavigate: 'mdm',
			right:                  'company.edit',
			minimizeHeaderUrl:      ['mdm/jamf', 'mdm/jamf/import'],
			minimizeHeader:         TEXTE.devices.backToMdm,

			render: (
				<div className={'flex-center'}>
					{TEXTE.header.devices.mdm}
					{!company?.isPro &&
						<Badge size={'sm'} color={'gray'} text={'Pro'} />
					}
				</div>
			)
		},
		{
			value:             'add',
			minimizeHeaderUrl: ['add/import'],
			right:             'company.edit',
			minimizeHeader:    TEXTE.devices.backToDevices,
			render:            TEXTE.header.devices.add
		},
		{
			soon:   true,
			value:  'redemption',
			right:  'company.edit',
			render: TEXTE.header.devices.redemption
		}
	];

	return (
		<div className={'globalContainerWithHeader'}>
			<Header
				menu={MENU_DATA}
				menuValue={params['*']}
				title={TEXTE.devices.title}
				badgeText={devices.length}
			/>

			<Routes>
				<Route path={'/'} element={<Devices />} />
				<Route
					path={'/add'}
					element={ft_checkRight(user, 'company.edit') ? <DevicesAdd /> : <Devices />}
				/>
				<Route
					path={'/add/:view'}
					element={ft_checkRight(user, 'company.edit') ? <DevicesAdd /> : <Devices />}
				/>
				<Route
					path={'/mdm'}
					element={ft_checkRight(user, 'company.edit') ? <DevicesMdm /> : <Devices />}
				/>
				<Route
					path={'/mdm/:name/import'}
					element={ft_checkRight(user, 'company.edit') ? <MdmImport /> : <Devices />}
				/>
				<Route path={'/redemption'} element={<div />} />
				<Route path={'/:idDevice'} element={<Devices />} />
			</Routes>
		</div>
	);
}

export default MainDevices;
